import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

export class LoginPBI {
  authType: 'user_password' | 'client_credentials' = 'user_password';
  // user_password
  user: string;
  password: string;
  applicationId: string;
  // client_credentials
  clientId: string;
  tenantId: string;
  clientSecret: string;
}

@Component({
  selector: 'app-connection-step-a',
  templateUrl: './connection-step-a.component.html',
  styleUrls: ['./connection-step-a.component.scss']
})
export class ConnectionStepAComponent implements OnInit {

  loginData: LoginPBI = new LoginPBI();
  passwordChanged = false;
  clientSecretChanged = false;

  @Output() login = new EventEmitter<LoginPBI>();
  @Input() user: string;
  @Input() authType: 'user_password' | 'client_credentials';
  @Input() applicationId: string;
  @Input() clientId: string;
  @Input() tenantId: string;
  @Input() editMode: boolean = false;
  @Input() hasExistingPassword: boolean = false;
  @Input() hasExistingClientSecret: boolean = false;
  @Input() error: string;
  constructor() { }

  ngOnInit() {
    if (this.authType) {
      this.loginData.authType = this.authType;
    }
    if (this.user) {
      this.loginData.user = this.user;
    }
    if (this.applicationId) {
      this.loginData.applicationId = this.applicationId;
    }
    if (this.clientId) {
      this.loginData.clientId = this.clientId;
    }
    if (this.tenantId) {
      this.loginData.tenantId = this.tenantId;
    }
  }

  emitLlogin() {
    this.login.emit(this.loginData);
  }
}
